export default {
  methods: {
    t (key, value) {
      if (this.store.resources) {
        if (value) {
          return this.store.resources[key].replace('$1', value) || key
        } else {
          return this.store.resources[key] || key
        }
      } else {
        return key
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/t.js